// Mirrors utilities.entities.lead_engagement_ledger.TransferFlagReason on the backend.
export type TransferFlagReason =
  | 'transferred_on_interruption'
  | 'silent_agent_transfer'
  | 'transferred_on_no_interest'
  | 'other';

export const TRANSFER_FLAG_REASON_LABELS: Record<TransferFlagReason, string> = {
  transferred_on_interruption: 'Transferred on interruption',
  silent_agent_transfer: 'Silent agent transfer',
  transferred_on_no_interest: 'Transferred on no interest',
  other: 'Other',
};

export const TRANSFER_FLAG_REASONS: TransferFlagReason[] = [
  'transferred_on_interruption',
  'silent_agent_transfer',
  'transferred_on_no_interest',
  'other',
];
